<script setup>
    import { date } from 'quasar'
    const router = useRouter();


    const sideBarVisible = ref(false);
    function toggleSideBar() {
        sideBarVisible.value = !sideBarVisible.value;
    }
</script>

<template>
    <page>
        <pageHeader title="Dashboard">
        </pageHeader>

        <div g-6-2>
                
        </div>
    </page>
</template>